module.exports = __webpack_public_path__ + "static/media/icon-pack.2d5d0382.png";